"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _defaultAnalyticsProps = require("../../../common/browser/analytics/defaultAnalyticsProps");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  page: {
    name: 'SP : Account',
    properties: _objectSpread(_objectSpread({}, _defaultAnalyticsProps.defaultPageProps), {}, {
      name: 'SP : Account',
      title: 'Business Center - Account'
    })
  },
  elements: {
    'personal-details--edit-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Section - Edit Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details--change-password-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Section - Change Password Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences--edit-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Section - Edit Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--add-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Add Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--delete-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Delete Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--primary-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Make Primary Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'change-password-modal--change-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Change Password Modal - Change Password Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'change-password-modal--cancel-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Change Password Modal - Cancel Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details-modal--close-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Modal - Close Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'add-address-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Add Address Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'add-address-modal--close-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Add Address Modal - Close Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences-modal--cancel-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Modal - Cancel Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    }
  }
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/office/browser/analytics/myAccount.js
// module id = 4058
// module chunks = 9